import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom';
import ReactGA from 'react-ga4';
import { LoadingSpinner } from '../../../../Components/Molecules/LoadingUI';
import { getConfig } from '../../../../utils/config';
import { useDispatch, useSelector } from 'react-redux';
import BsArrowLeft from '@meronex/icons/bs/BsArrowLeft';
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from 'react-share';
import Sidebar from '../../../Blogs/Components/Sidebar';
import useDataEventDetails from './data';
import useData from '../../data';
import { cmsClient, winnreAuth, winnreNoAuth } from '../../../../utils/axios';
import { authActions } from '../../../../store/auth-slice';
import Modal from '../../../../Components/Organisms/Modal';
import GrClose from '@meronex/icons/gr/GrClose';

const EventsDetails = ({ event, isLoading }) => {
    const params = useParams();
    const config = getConfig();
    const history = useHistory();
    const clientWebview = useSelector((state) => state.webView.clientWebview);
     const [showUnregisteredModal, setShowUnregisteredModal] = useState(false);
    const { events: pastEvents, isLoading: isLoadingEvents } = useData({
        isPast: true,
        checkProtectedEvents: false
    });
    const isUserAuthenticated = useSelector(
        (state) => state.auth.isAuthenticated
    );
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const userId = useSelector((state) => state.auth.userId);
    const clickThroughMobile = clientWebview || internalWebview;
    const dispatch=useDispatch();
    const userStatus = useSelector((state) => state.auth.userDetails?.status);
    const openLoginModal = () => {
        dispatch(authActions.openLoginModal());
    };

    const registerHandler = () => {
        if (!isUserAuthenticated) {
            openLoginModal();
            return;
        }
        if (userStatus !== 'REGISTERED') {
            setShowUnregisteredModal(true);
            return;
        }
        if (
            cmsClient.defaults.baseURL === 'https://prod.loyalie.in' ||
            cmsClient.defaults.baseURL === 'https://uat.loyalie.in'
        ) {
            window.fbq('trackCustom', 'EventRegistration');
        }
        ReactGA.event({
            category: 'EVENTS',
            action: 'EVENT REGISTRATION CLICKED',
            label: 'REGISTER NOW BUTTON'
        });
        window?.webengage?.track('RegisterNow', {
            EventName: `${event?.title}`
        });
            winnreAuth({
                method: 'POST',
                url: `winnre/user/events/register?eventId=${
                    event?.id
                }&userId=${userId}&sourcePlatform=${
                    clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                }`
            })
                .then(() => {})
                .catch(() => {});
        
        window.open(event?.registerationUrl);
    };
    
    return (
        <div>
            <div
                className={`
                    ${config?.bannerNegativeTopMarginClass} w-full h-auto `}
            >
                {isLoading && (
                    <div className="h-screen">
                        {' '}
                        <LoadingSpinner />
                    </div>
                )}
                {!isLoading && (
                    <div className="relative w-full  lg:sticky lg:top-0 h-full">
                        <img
                            src={event?.displayImage?.url}
                            className=" w-full h-full object-scale-down"
                        />

                        <div
                            onClick={() => history.goBack()}
                            className="absolute flex justify-center items-center top-2 left-2 rounded-full h-10 w-10 bg-[#ffffffb3]"
                        >
                            <BsArrowLeft className="text-black w-6 h-full cursor-pointer" />
                        </div>
                    </div>
                )}
            </div>
            <section
                style={{
                    backgroundImage: `linear-gradient(90deg, rgba(${
                        config?.sectionBackground?.color
                    }, ${config?.sectionBackground?.opacity}), rgba(${
                        config?.sectionBackground?.color
                    }, ${config?.sectionBackground?.opacity})), url('${
                        config?.sectionBackground?.image
                            ? config?.sectionBackground?.image
                            : ''
                    }')`,
                    backgroundSize: `${
                        config?.sectionBackground?.size
                            ? config?.sectionBackground?.size
                            : '30% auto'
                    }`
                }}
                className={
                    `${
                        config?.events.eventsSection.overlayClass
                            ? 'relative'
                            : ''
                    }` + ' min-h-screen w-full'
                }
            >
                {config?.events.eventsSection.overlayClass ? (
                    <div
                        className={
                            `${config?.events.eventsSection.overlayClass}` +
                            ' absolute top-0 bottom-0 left-0 right-0 z-0'
                        }
                    ></div>
                ) : null}
                <main className="z-10 min-h-full flex flex-col-reverse lg:pt-5 lg:flex-row -mt-6">
                    <section className="z-10 w-full lg:w-[70%] pl-4 pr-4 xl:pl-16 xl:pr-16 2xl:pl-20 2xl:pr-20 pb-10">
                        <div
                            className={
                                `${config?.blogs.detailsPageBackgroundColor}` +
                                ' md:px-4 py-6'
                            }
                        >
                            <h1
                                className={`font-bold text-black uppercase pb-4 text-xl xl:text-2xl ${config?.events?.fontHeading}`}
                            >
                                {event?.title}
                            </h1>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: event?.description
                                }}
                                className={`min-h-full text-base text-black ${
                                    config?.darktheme
                                        ? config?.deals.darkTheme?.text ||
                                          'text-[#c2c2c2]'
                                        : ''
                                } `}
                            ></div>
                                <button
                                    className={
                                        'mt-4 disabled:bg-gray-200 disabled:text-white -ml-1 ' +
                                        config?.clientButtonClassName
                                    }
                                    disabled={!event?.registerationUrl}
                                    onClick={registerHandler}
                                >
                                    REGISTER NOW
                                </button>
                        </div>
                        <div className="md:px-4 flex flex-col-reverse xl:flex-row justify-between">
                            <div>
                                <p className=" self-center text-sm text-primary">
                                    If you like the event, please feel free to
                                    share
                                </p>
                                <div className="mt-1">
                                    <WhatsappShareButton
                                        url={window.location.href}
                                    >
                                        <WhatsappIcon size={30} />
                                    </WhatsappShareButton>
                                    <FacebookShareButton
                                        url={window.location.href}
                                    >
                                        <FacebookIcon size={30} />
                                    </FacebookShareButton>
                                    <LinkedinShareButton
                                        url={window.location.href}
                                    >
                                        <LinkedinIcon size={30} />
                                    </LinkedinShareButton>
                                    <EmailShareButton
                                        url={window.location.href}
                                    >
                                        <EmailIcon size={30} />
                                    </EmailShareButton>

                                    <TwitterShareButton
                                        url={window.location.href}
                                    >
                                        <svg
                                            size={30}
                                            className="w-7 text-black"
                                            stroke="currentColor"
                                            fill="currentColor"
                                            stroke-width="0"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z"></path>
                                        </svg>
                                    </TwitterShareButton>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="z-10 flex-col w-full mb-7 lg:mb-0 lg:w-[30%] ">
                        <Sidebar
                            pastEvents={pastEvents}
                            isLoadingEvents={isLoadingEvents}
                            showPastEvents={true}
                            showSearch={false}
                            showRecentBlogs={false}
                            showCategories={false}
                        />
                    </section>
                </main>
            </section>
            <Modal
                className="w-[95%] md:w-[55%] lg:w-[50%] xl:w-[45%]"
                visible={showUnregisteredModal}
                onClick={() => setShowUnregisteredModal(false)}
            >
                <div className="flex justify-end mr-4 mt-4">
                    <GrClose
                        onClick={() => setShowUnregisteredModal(false)}
                        className={` h-4 w-4 cursor-pointer self-end ml-auto`}
                    />
                </div>
                <div className="text-left px-4 pb-8">
                    <h1 className='font-bold text-xl'>Hello There</h1>
                    <p className="text-sm lg:text-base font-medium mt-2">
                        Your registration is being reviewed.
                    </p>
                    <p className="text-sm lg:text-base font-medium mt-1">
                    Your account is currently under review. Once approved, you'll be able to register for events and enjoy all the benefits we offer.
                    </p>
                </div>
            </Modal>
        </div>
    );
};

export default EventsDetails;
